/* eslint-disable */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Layout,
  Dropdown,
  Avatar,
  Badge,
  Modal,
  Form,
  Input,
  Button,
  message,
  Space,
  Typography,
} from 'antd';
import {
  UserOutlined,
  MenuOutlined,
  KeyOutlined,
  LogoutOutlined,
  FileTextOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

const { Header } = Layout;
const { Text } = Typography;

function Navbar(props) {
  const [form] = Form.useForm();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);

  const handlePasswordChange = async (values) => {
    if (values.password !== values.confirmPassword) {
      message.error('รหัสผ่านไม่ตรงกัน');
      return;
    }

    setPasswordLoading(true);

    const formdata = new FormData();
    formdata.append('username', props.permitdata.username);
    formdata.append('password', values.password);

    try {
      const response = await axios.post(
        props.app_hostname + '/api/account/office/changepassword',
        formdata,
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + props.permitdata.token,
          },
        },
      );

      setPasswordLoading(false);

      if (response.data.status === 'OK') {
        message.success('เปลี่ยนรหัสผ่านสำเร็จ ระบบจะออกจากระบบอัตโนมัติ', 2, () => {
          props.callback_signout('x');
        });
        setIsPasswordModalOpen(false);
        form.resetFields();
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาด');
      }
    } catch (err) {
      setPasswordLoading(false);
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    }
  };

  const handleLogout = () => {
    Modal.confirm({
      title: 'ยืนยันการออกจากระบบ',
      content: 'คุณแน่ใจหรือไม่ที่จะออกจากระบบ?',
      okText: 'ออกจากระบบ',
      cancelText: 'ยกเลิก',
      onOk: () => {
        props.callback_signout('x');
      },
    });
  };

  // User dropdown menu items
  const userMenuItems = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '8px 0', minWidth: '280px' }}>
          <div style={{ marginBottom: '8px' }}>
            <Text strong style={{ fontSize: '16px', display: 'block' }}>
              <UserOutlined style={{ marginRight: '8px' }} />
              {props.permitdata.username}
            </Text>
            <Text type='secondary' style={{ display: 'block', fontSize: '13px' }}>
              {props.permitdata.email}
            </Text>
          </div>
          <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
            <Text type='secondary' style={{ fontSize: '12px' }}>
              Login: {dayjs(props.permitdata.logintime).format('DD MMM YYYY HH:mm:ss')}
            </Text>
          </div>
          <div style={{ marginTop: '4px' }}>
            <Badge
              count={props.permitdata.role}
              style={{
                backgroundColor: props.permitdata.role === 'admin' ? '#f50' : '#1890ff',
              }}
            />
          </div>
        </div>
      ),
      disabled: true,
    },
    {
      key: 'change-password',
      icon: <KeyOutlined />,
      label: 'เปลี่ยนรหัสผ่าน',
      onClick: () => {
        form.resetFields();
        setIsPasswordModalOpen(true);
      },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'ออกจากระบบ',
      onClick: handleLogout,
      danger: true,
    },
  ];

  return (
    <>
      <Header
        style={{
          position: 'fixed',
          zIndex: 100,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#1e293b',
          padding: '0 24px',
          boxShadow: '0 4px 6px -1px rgba(15, 23, 42, 0.12)',
          borderBottom: '1px solid #334155',
          height: '64px',
        }}
      >
        {props.isMobile && (
          <Button
            className='mobile-menu-btn'
            type='text'
            icon={<MenuOutlined style={{ fontSize: '20px', color: '#ffffff' }} />}
            onClick={props.onToggleMobileMenu}
            style={{ padding: 0, width: '40px', height: '40px', marginRight: '8px' }}
          />
        )}

        {!props.isMobile && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '200px' }}>
            <img
              src='/images/Meya-logo1.png'
              alt='Meya Logo'
              style={{ height: '32px', width: 'auto' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.3' }}>
              <Text strong style={{ fontSize: '16px', margin: 0, color: '#ffffff' }}>
                MEYA
              </Text>
              <Text style={{ fontSize: '10px', margin: 0, color: '#94a3b8' }}>
                Management Platform
              </Text>
            </div>
          </div>
        )}

        {!props.isMobile && (
          <div style={{ flex: 1, textAlign: 'center' }}>
            <Text strong style={{ fontSize: '16px', color: '#ffffff' }}>
              Meya Management Tool for Office
            </Text>
          </div>
        )}

        {props.isMobile && <div style={{ flex: 1 }} />}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: props.isMobile ? '8px' : '16px',
            minWidth: props.isMobile ? 'auto' : '200px',
            justifyContent: 'flex-end',
          }}
        >
          {props.slip_unread > 0 && (
            <Link to='/order/payslip'>
              <Badge count={props.slip_unread} offset={[-5, 5]}>
                <FileTextOutlined
                  style={{ fontSize: '20px', color: '#fa8c16', cursor: 'pointer' }}
                />
              </Badge>
            </Link>
          )}

          {props.messages_chat_unread > 0 && (
            <Link to='/helpdesk/chat'>
              <Badge count={props.messages_chat_unread} offset={[-5, 5]}>
                <MessageOutlined
                  style={{ fontSize: '20px', color: '#fa8c16', cursor: 'pointer' }}
                />
              </Badge>
            </Link>
          )}

          <Text style={{ marginRight: '8px', color: '#e2e8f0', fontWeight: '500' }}>
            {props.permitdata.username}
          </Text>

          <Dropdown menu={{ items: userMenuItems }} trigger={['click']} placement='bottomRight'>
            <Avatar
              icon={<UserOutlined />}
              style={{ backgroundColor: '#1890ff', cursor: 'pointer' }}
            />
          </Dropdown>
        </div>
      </Header>

      <Modal
        title={
          <Space>
            <KeyOutlined />
            เปลี่ยนรหัสผ่านของคุณ
          </Space>
        }
        open={isPasswordModalOpen}
        onCancel={() => {
          setIsPasswordModalOpen(false);
          form.resetFields();
        }}
        footer={null}
        centered
        width={400}
      >
        <Form
          form={form}
          layout='vertical'
          onFinish={handlePasswordChange}
          style={{ marginTop: '24px' }}
        >
          <Form.Item
            name='password'
            label='รหัสผ่านใหม่'
            rules={[
              { required: true, message: 'กรุณากรอกรหัสผ่านใหม่' },
              {
                pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                message:
                  'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวเลข ตัวพิมพ์เล็ก และตัวพิมพ์ใหญ่',
              },
            ]}
            hasFeedback
          >
            <Input.Password placeholder='กรอกรหัสผ่านใหม่' />
          </Form.Item>

          <Form.Item
            name='confirmPassword'
            label='ยืนยันรหัสผ่านใหม่'
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'กรุณายืนยันรหัสผ่าน' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('รหัสผ่านไม่ตรงกัน'));
                },
              }),
            ]}
          >
            <Input.Password placeholder='ยืนยันรหัสผ่านใหม่' />
          </Form.Item>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
              marginTop: '24px',
            }}
          >
            <Button
              onClick={() => {
                setIsPasswordModalOpen(false);
                form.resetFields();
              }}
            >
              ยกเลิก
            </Button>
            <Button type='primary' htmlType='submit' loading={passwordLoading}>
              {passwordLoading ? 'กำลังดำเนินการ...' : 'ยืนยัน'}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}

Navbar.propTypes = {
  permitdata: PropTypes.shape({
    username: PropTypes.string,
    email: PropTypes.string,
    logintime: PropTypes.string,
    role: PropTypes.string,
    token: PropTypes.string,
  }).isRequired,
  app_hostname: PropTypes.string.isRequired,
  callback_signout: PropTypes.func.isRequired,
  messages_chat_unread: PropTypes.number,
  slip_unread: PropTypes.number,
  isMobile: PropTypes.bool,
  onToggleMobileMenu: PropTypes.func,
};

export default Navbar;
